import { create } from "zustand";
import { combine } from "zustand/middleware";

import { sharedTariffStateMutators, TariffData } from "@stores/tariff/utils.ts";

export type ComparisonTariffData = TariffData;

const DEFAULT_COMPARISON_TARIFF_DATA: ComparisonTariffData = {
  useTariff: false,
  standingCharge: null,
  exportRate: null,
  tariffPoints: [],
};

export const useComparisonTariffStore = create(
  combine(DEFAULT_COMPARISON_TARIFF_DATA, (set) => ({
    ...sharedTariffStateMutators(set),
  })),
);
